import { NextSeo } from 'next-seo';
import PrivacyPage from '_components/composed/pages/PrivacyPage';

export default function Privacy() {
  return (
    <>
      <NextSeo title="Privacy" />
      <PrivacyPage />
    </>
  );
}
